import { Button, notification } from "antd";
import { CloudDownloadOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { exportCandidates } from "api/candidate.api";
import ExpandableButton from "components/Common/Button/ExpandableButton";
import { useFeatureAllowedFromState } from "services/CustomeHooks";
import { FEATURE_CONSTANTS } from "components/constants/AppConstants";

interface Props {
    type?: "select" | "reject" | "import" | "suggest";
    roleId: any;
    title: string;
    candidates?: any;
    disabled?: boolean;
}
const CSVDownloader: React.FC<Props> = ({
    type,
    roleId,
    title,
    candidates,
    disabled = false,
}) => {
    const [loading, setLoading] = useState(false);
    const isExportProfileAllowed = useFeatureAllowedFromState(FEATURE_CONSTANTS.FCECPM);

    const downloadFile = (data: any, filename: string) => {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link: any = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    };

    const handleProfileExportError = () => {
        notification.error({
            message: "Failed",
            description: "Could not export profile please enable feature!"
        });
    };

    const downloadCandidates = () => {
        setLoading(true);
        if (type === "select") {
            exportCandidates({
                job_id: roleId,
                candidate_ids: candidates ? candidates : [],
                candidate_type: "shortlisted-candidates",
            }).then(
                (data) => {
                    setLoading(false);
                    downloadFile(data, (title ? title : "") + "_Selected_Candidates.csv");
                },
                (e) => {
                    setLoading(false);
                    notification.error({
                        message: e.message ? e.message : "No rejected candidates found",
                    });
                }
            );
        }
        if (type === "suggest") {
            exportCandidates({
                job_id: roleId,
                candidate_ids: candidates ? candidates : [],
                candidate_type: "suggested-candidates",
            }).then(
                (data) => {
                    setLoading(false);
                    downloadFile(
                        data,
                        (title ? title : "") + "_Suggested_Candidates.csv"
                    );
                },
                (e: any) => {
                    setLoading(false);
                    notification.error({
                        message: e.message ? e.message : "No rejected candidates found",
                    });
                }
            );
        }
        if (type === "import") {
            exportCandidates({
                job_id: roleId,
                candidate_ids: candidates ? candidates : [],
                candidate_type: "imported-candidates",
            }).then(
                (data) => {
                    setLoading(false);
                    downloadFile(data, (title ? title : "") + "_Imported_Candidates.csv");
                },
                (e) => {
                    setLoading(false);
                    notification.error({
                        message: e.message ? e.message : "No rejected candidates found",
                    });
                }
            );
        }
        if (type === "reject") {
            exportCandidates({
                job_id: roleId,
                candidate_ids: candidates ? candidates : [],
                candidate_type: "rejected-candidates",
            }).then(
                (data) => {
                    setLoading(false);
                    downloadFile(data, (title ? title : "") + "_Rejected_Candidates.csv");
                },
                (e) => {
                    setLoading(false);
                    notification.error({
                        message: e.message ? e.message : "No rejected candidates found",
                    });
                }
            );
        }
    };

    return (
        <>
            <ExpandableButton
                icon={<svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                >
                    <path
                        d="M17.5 10V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V10M13.3333 5.83333L10 2.5M10 2.5L6.66667 5.83333M10 2.5V12.5"
                        stroke="white"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>}
                text="Export to CSV"
                onClick={() => {
                    isExportProfileAllowed ?
                        downloadCandidates() : handleProfileExportError();
                }}
            />

        </>
    );
};

export default CSVDownloader;
